import {
  KeyboardArrowDown as KeyboardArrowDownIcon,
  KeyboardArrowUp as KeyboardArrowUpIcon,
} from '@mui/icons-material';
import {
  Box,
  styled,
  TableCell,
  TableContainer,
  TableRow,
} from '@mui/material';

export const CustomTableCell = styled(TableCell)<{ isdoublewidth: string }>`
  width: 10px;
  font-size: 16px;
  max-width: 300px;

  & a {
    color: inherit;
  }
`;

export const TableHeadCell = styled(Box)`
  display: flex;
  border: none;
  justify-content: start;
  align-items: center;
  gap: 20px;
`;

export const SortIcons = styled(Box)`
  width: 14px;
  height: 31px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin-right: 0px;
`;

export const ArrowIcon = styled(Box)`
  height: 20px;
  cursor: pointer;
`;

export const KeyboardArrowUpIconStyled = styled(KeyboardArrowUpIcon)<{
  active: boolean;
  theme: { palette: { primary: { main: string } } };
}>((props) => ({
  color: props.active ? props.theme.palette.primary.main : 'inherit',
  fontSize: '20px',
}));

export const KeyboardArrowDownIconStyled = styled(KeyboardArrowDownIcon)<{
  active: boolean;
  theme: { palette: { primary: { main: string } } };
}>((props) => ({
  color: props.active ? props.theme.palette.primary.main : 'inherit',
  fontSize: '20px',
}));

export const CustomTableRow = styled(TableRow)(
  ({ theme }) => `
   border-bottom: 1px solid ${theme.palette.brand.disable};
  `,
);

export const TableBodyContainer = styled(TableContainer)`
  height: 92vh;
  overflow: auto;
`;

export const InViewBoxContainer = styled(Box)`
  height: 50px;
`;

export const ButtonWrapper = styled(Box)`
  position: fixed;
  right: 30px;
  top: 30px;
`;
